module.exports = __webpack_public_path__ + "static/ProximaNova-Semibold-3625e925425cb102cadb2f5db79c9aa0.ttf";